import React from 'react';
import ReactDOM from 'react-dom';
import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';
import { split } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { getMainDefinition } from 'apollo-utilities';
import './styles/index.scss';
import App from './containers/App';
import registerServiceWorker from './registerServiceWorker';
import * as Sentry from '@sentry/browser';
import { MockedProvider } from 'react-apollo/test-utils';
import mocks from './mocks/mock-graphql-operations/mocks';

const { API_URL, WS_API_URL, SENTRY_DSN, NODE_ENV } = process.env;

const ORG_NAME = window.location.href.indexOf('?school=') !== -1 ?
    window.location.href.substr(window.location.href.indexOf('?school=') + '?school='.length) :
    window.location.hostname.split('.')[0];

Sentry.init({ dsn: SENTRY_DSN });

const headers = setContext(() => ({
    headers: { orgName: ORG_NAME },
}));

const httpLink = new HttpLink({
    uri: `${API_URL}/graphql`,
});

const wsLink = new WebSocketLink({
    uri: `${WS_API_URL}/graphql`,
    options: {
        reconnect: true,
        connectionParams: { orgName: ORG_NAME },
    },
});

const link = split(
    ({ query }) => {
        const { kind, operation } = getMainDefinition(query);
        return kind === 'OperationDefinition' && operation === 'subscription';
    },
    wsLink,
    headers.concat(httpLink),
);

const client = new ApolloClient({
    link,
    cache: new InMemoryCache(),
});

ReactDOM.render(
    NODE_ENV === 'development' ?
        <MockedProvider mocks={mocks} addTypename={false}>
            <App />
        </MockedProvider> :
        <ApolloProvider client={client}>
            <App />
        </ApolloProvider>,
    document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js